
<div class="row" >
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
     <div class="card card-border">
      <div class="card-body" id = "example_wrapper">
            <form [formGroup] = "smsForm">
           <div class="row">
              <div class="col-sm-12">
                  <div class="form-group">
                      <label for="description" class="required">Description:</label>
                      <!-- <quill-editor 
                        [modules]="{ toolbar: toolbarOptions }"
                        [styles]="{height: '200px'}"
                        formControlName="description"
                        placeholder="Enter your message..."
                    ></quill-editor> -->
                    <textarea
                    class="form-control"
                    rows="6"
                    formControlName="description"
                    placeholder="Enter your message..."
                    ></textarea>
                       <!-- <div class="text-danger mt-2" *ngIf="submitted && smsForm.get('description')?.errors?.required">Description is required</div> -->
                  </div>
              </div>
             </div>    
          <div class="justify-content-center d-flex mt-4">
            <button type="submit" class="btn btn-submit mr-3" (click) ="createBlog()">Submit</button>
          </div>
        </form>
      </div>
     </div>
    </div>
  </div>
  